import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const assignPermissionsToTenants = async (id, updatedTenants) => {
  try {
    const response = await apiClient.post(`/tenant/assignTenantPermissions/${id}`, updatedTenants);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
